import { apiClient } from "./api";
import { isAxiosError } from "axios";
import {
  CollectionEstablecimientoNivelUsuario,
  IEstablecimiento,
  INivel,
} from "@/interfaces/generalInterfaces";

class FacturadorService {
  private basicURL: string;

  constructor() {
    this.basicURL = "/Facturador";
  }

  async getProfesionalesFacturador(idFacturador: string) {
    const endpoint = `${this.basicURL}/GetProfesionalesFacturador`;
    const body = JSON.stringify({
      idFacturador: idFacturador
    });
    try {
    const response = await apiClient.post(endpoint, body);
    return response;
    } catch (error : unknown) {
    if (isAxiosError(error)) {
        return error.response;
    }
    return "Error al traer la lista de profesionales";
    }
  }

    async getProfesionalesSinExpiracionFacturador(idFacturador: string) {
    const endpoint = `${this.basicURL}/GetProfesionalesFacturadorSinExpiracion`;
    const body = JSON.stringify({
      idFacturador: idFacturador
    });
    try {
    const response = await apiClient.post(endpoint, body);
    return response;
    } catch (error : unknown) {
    if (isAxiosError(error)) {
        return error.response;
    }
    return "Error al traer la lista de profesionales";
    }
  }

  async getFacturadoresConCarga(){
    const endpoint = `${this.basicURL}/GetFacturadoresConCarga`;
    try{
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Unknown error occurred");
      }
    }
  }

  async getObrasSociales(facturadorId: string){
    const endpoint = 'ObraSocial/ListarObrasSociales';
    const body = JSON.stringify({
      facturadorId: facturadorId
    });
    try{
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Unknown error occurred");
      }
    }
  }

  async getObrasSocialesTotales(){
    const endpoint = 'ObraSocial/GetObrasSocialesTotales';
    try{
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Unknown error occurred");
      }
    }
  }

  async getObrasSocialesBandejas(){
    const endpoint = 'ObraSocial/GetObrasSocialesBandejas';
    try{
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Unknown error occurred");
      }
    }
  }

  async getEstablecimientosUsuario(
    usuNivEst: CollectionEstablecimientoNivelUsuario
  ) {
    const establecimientos: IEstablecimiento[] = [];
    usuNivEst.forEach((element) => {
      if (
        establecimientos.find(
          (x) => x.id == element.facturador.id
        ) == undefined
      ) {
        establecimientos.push(element.facturador);
      }
    });
    return establecimientos;
  }

  async getModosPorEstablecimiento(
    usuNivEst: CollectionEstablecimientoNivelUsuario,
    idEstablecimiento: string
  ) {
    const modos: INivel[] = [];
    usuNivEst.forEach((element) => {
      if (element.facturador.id == idEstablecimiento) {
        modos.push(element.nivel);
      }
    });
    return modos;
  }

  async getFacturadoresTotales(){
    const endpoint = `${this.basicURL}/GetFacturadores`;
    try{
      const response = await apiClient.get(endpoint);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Error desconocido al traer listado de facturadores");
      }
    }
  }

  async getFacturadoresPorObraSocial(obraSocialId: string){
    const endpoint = `${this.basicURL}/GetFacturadoresAuditorOS`;
    const body = JSON.stringify({
      id: obraSocialId
    });
    try{
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Error desconocido al traer listado de facturadores por obra social");
        return error;
      }
    }
  }

  async getFacturadoresBandeja(usuarioId: string){
    const endpoint = `${this.basicURL}/GetFacturadoresAutorizadorBandeja`;
    const body = JSON.stringify({
      id: usuarioId
    });
    try{
      const response = await apiClient.post(endpoint, body);
      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error(error.message);
        return error.message;
      } else {
        console.error("Error desconocido al traer listado de facturadores por bandeja");
        return error;
      }
    }
  }
}

export default FacturadorService;
